export { AtnRulesComponent as Component } from './page.component'
export * as components from './components'
